module.exports = __webpack_public_path__ + "media/dealer/dealerTab1-11f4104f.jpg";